/** Time window presets for the dashboard header date widget. */
export const TIME_WINDOW_OPTIONS = [
  'All Time',
  'Last Hour',
  'Last 8 Hours',
  'Last 12 Hours',
  'Last 24 Hours',
  'Last 48 Hours',
  'Last 72 Hours',
  'Last Week',
] as const;

export type TimeWindowOption = (typeof TIME_WINDOW_OPTIONS)[number];

const HOURS: Record<string, number> = {
  'Last Hour': 1,
  'Last 8 Hours': 8,
  'Last 12 Hours': 12,
  'Last 24 Hours': 24,
  'Last 48 Hours': 48,
  'Last 72 Hours': 72,
  'Last Week': 168,
};

/** Returns a cutoff Date for the given time window, or null for 'All Time'. */
export function timeWindowCutoff(tw: TimeWindowOption | string): Date | null {
  const h = HOURS[tw];
  if (h == null) return null;
  return new Date(Date.now() - h * 3_600_000);
}

/** Common timestamp field names (tried in order). */
export const TIMESTAMP_FIELDS = ['timestamp', 'observed_at', 'time', 'datetime', 'date', 'created_at'] as const;
